import React, { Component } from 'react'
import { Logo } from '../../components/Layout'
import { ConfirmForm } from './components'

export default class extends Component {
  render () {
    const { token } = this.props.match.params

    return (
      <div className='login app__login'>
        <div className='login__container'>
          <div className='login__wrapper'>
            <div className='login__logo'>
              <Logo width='64' />
            </div>
            <div className='login__content'>
              <ConfirmForm token={token} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Confirm/Confirm.jsx